import { render, staticRenderFns } from "./MegaMenuEditor.vue?vue&type=template&id=10f42376"
import script from "./MegaMenuEditor.vue?vue&type=script&lang=js"
export * from "./MegaMenuEditor.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuEditor.vue?vue&type=style&index=0&id=10f42376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports